import { CustomerDocument } from '@app/graphql/types'
import { useCustomerForPrintViewQuery } from '@app/queries/CustomerForPrintView/CustomerForPrintView.queries'

export const usePrintViewData = ({ customerId }) => {
  const { data, loading, error } = useCustomerForPrintViewQuery({
    variables: {
      id: customerId
    }
  })

  if (!data) {
    return {
      loading,
      error,
      contactDetails: {},
      messagesForTable: [],
      messagesForList: [],
      appointments: []
    }
  }

  const contactDetails = {
    dateOfBirth: data.customer.dateOfBirth ? new Date(data.customer.dateOfBirth) : undefined,
    email: data.customer.email,
    firstName: data.customer.firstName || undefined,
    lastName: data.customer.lastName || undefined,
    phone: data.customer.phone || undefined,
    address: {
      street: data.customer.address?.street || undefined,
      city: data.customer.address?.city || undefined,
      zip: data.customer.address?.zip || undefined,
      country: data.customer.address?.country || undefined
    },
    membership: {
      displayName: data.customer.membership?.product.name,
      memberSince: data.customer.membership?.activatedAt
    }
  }

  const messages = data.customer.chat.items

  const messagesForList = messages.map((message) => {
    return {
      lawyer: {
        firstName: message.lawyer?.firstName,
        lastName: message.lawyer?.lastName
      },
      type: message.type,
      topic: message.topic.name,
      topicQuestionnaireAnswers: message.topicQuestionnaireAnswers,
      content: message.content || '',
      documents:
        message.documents?.map((doc) => {
          return {
            id: doc.id,
            name: doc.name,
            category: 'category' in doc ? doc.category?.name : undefined
          }
        }) || [],
      sentAt: new Date(message.sentAt),
      createdAt: new Date(message.createdAt),
      approvedAt: new Date(message.approvedAt),
      appointmentAt: message.appointmentAt ? new Date(message.appointmentAt) : undefined,
      id: message.id,
      customer: {
        firstName: data.customer.firstName || undefined,
        lastName: data.customer.lastName || undefined
      },
      utilityBillMetadata:
        (message.documents?.find((doc) => 'metadata' in doc) as CustomerDocument)?.metadata
          .utilityBillCheck || undefined
    }
  })

  const appointments = messages.reduce((acc, message) => {
    if (message.appointmentAt) {
      return [
        ...acc,
        {
          lawyer: {
            firstName: message.lawyer?.firstName,
            lastName: message.lawyer?.lastName
          },
          appointmentAt: new Date(message.appointmentAt),
          id: message.id
        }
      ]
    }
    return acc
  }, [])

  return {
    loading,
    error,
    contactDetails,
    messagesForList,
    appointments
  }
}
